import { render, staticRenderFns } from "./GreenCircles.vue?vue&type=template&id=2574fe0b&scoped=true&"
import script from "./GreenCircles.vue?vue&type=script&lang=js&"
export * from "./GreenCircles.vue?vue&type=script&lang=js&"
import style0 from "./GreenCircles.vue?vue&type=style&index=0&id=2574fe0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2574fe0b",
  null
  
)

export default component.exports